<template>
    <div class="ur-segment-wrapper ur-input" :class="wrapperClass">
        <!--
            $ver:v0.1.1
            여러 <em>ur-segment-button</em> 컴포넌트를 하나로 묶기 위한 영역입니다.
            #An area for grouping multiple <em>ur-segment-button</em> components into one.
        -->
        <slot></slot>
        <!--
        FIXME: validator 넣어놓긴 했는데 absolute로 띄우고 메시지 출력하는걸 깜빡함.
        css 설정 필요. radio wrapper같은거 참고하면 좋을듯.
        -->
        <div v-if="messageShow" :style="$_messageStyle()"
             class="ur-segment-wrapper__message ur-validator__message">{{messageShow}}</div>
    </div>
</template>

<script>
    import urValidatorMixin from '../../../mixins/urValidator/urValidatorMixin.vue';
    //ur-segment-wrapper는 여러 개의 Segment Button을 감싸 하나의 세트로 묶기 위한 컴포넌트 입니다.
    //#ur-segment-wrapper is used to wrap multiple segment buttons to control like a set.
    export default {
        name: 'ur-segment-wrapper',
        mixins: [urValidatorMixin],
        model: {
            prop: 'checked',
        },
        inject: {
            urInput: {from:'urInput', default: () => undefined}
        },
        props: {
            // $ver: v0.1.2
            // $v-model
            // v-model로 바인딩 되는 값입니다. <em>ur-segment-wrapper</em>하위에 존재하는
            // <em>ur-segment-button</em>의 v-model을 덮어씁니다.(단, group이 다른 경우 제외)
            // #The value bound to v-model. Overrides the v-model of <em>ur-segment-button</em> that exists under <em>ur-segment-wrapper</em> (unless group is different)
            checked: {type: [Boolean, String, Array]},
            // $ver: v0.1.2
            // 하단에 표시되는 가이드 메시지입니다. 별도의 설정이 없다면 출력되지 않습니다.
            // <em>ur-segment-wrapper</em>는 메시지 출력을 위한 공간을 별도로 점유하지않습니다.
            // 메시지 출력을 원할 경우 공간확보가 필요합니다.
            // #The guide message that appears at the bottom. If there is no setting, no output.
            // #<em>ur-segment-wrapper</em> does not occupy any space for message output.
            // #If you want to output a message, you need to make space.
            guideMessage: {type:String, default: undefined},
            // $ver: v0.1.2
            // validate를 통과한 경우 출력되는 메시지입니다.
            // 별도설정이 없다면 가이드 메시지가 출력되거나 아무런 메시지도 출력되지 않습니다.
            // <em>ur-segment-wrapper</em>는 메시지 출력을 위한 공간을 별도로 점유하지않습니다.
            // 메시지 출력을 원할 경우 공간확보가 필요합니다.
            // #The message that is output if validate passes.
            // #If there is no setting, guide message or no message is printed.
            // #<em>ur-segment-wrapper</em> does not occupy any space for message output.
            // #If you want to output a message, you need to make space.
            successMessage: {type:String, default: undefined},
            // $ver: v0.1.2
            // <em>ur-segment-wrapper</em>하위에 존재하는 <em>ur-segment-button</em>중에서
            // <em>ur-segment-wrapper</em>와 group이 같게 설정된 <em>ur-segment-button</em>만 영향을 받게됩니다.
            // segment-wrapper와 segment-button 모두 기본값은 'default'로 설정되어있습니다.
            // #<em>ur-segment-button</em> from the <em>ur-segment-wrapper</em>,
            // #Only <em>ur-segment-button</em> with the same <em>ur-segment-wrapper</em> and group set will be affected.
            // #Both segment-wrapper and segment-button are set to 'default' by default.
            group: {
                type: String,
                default: 'default'
            },
            // $ver: v0.1.2
            // <em>ur-segment-wrapper</em>하위에 존재하는 <em>ur-segment-button</em>를 disabled 상태로 설정합니다.
            // <em>ur-segment-wrapper</em>와 group 이 같게 설정된 <em>ur-segment-button</em>만 영향을 받게됩니다.
            // #Set the <em>ur-segment-button</em> below the <em>ur-segment-wrapper</em> to the disabled state.
            // #Only <em>ur-segment-button</em> with the same <em>ur-segment-wrapper</em> and group set will be affected.
            // $default: false
            disabled: {
                type: Boolean,
                default: false
            },
            // $ver: v0.2.0
            // 색상 유형 입니다. 'primary','point','normal', 'red', 'orange', 'green' 유형 중 하나를 입력해야 합니다.
            // #The color type. You must enter one of these types: 'primary','point','normal', 'red', 'orange', 'green'.
            // $default: normal
            color:{
                validator: function (value) {
                    // The value must match one of these strings
                    return ['primary', 'point', 'normal', 'red', 'orange', 'green'].indexOf(value) !== -1
                },
            },
            // $ver: v0.1.2
            // 선택된 <em>ur-segment-button</em>의 색상을 Primary 색상으로 정의합니다.
            // #Defines the color of the selected <em>ur-segment-button</em> as the primary color.
            // $default: false
            primary: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // $abbr: primary
            prim: {
                type:Boolean,
                default: false,
            },
            // $ver: v0.1.2
            // 선택된 <em>ur-segment-button</em>의 색상을 Point 색상으로 정의합니다.
            // #Defines the color of the selected <em>ur-segment-button</em> as the Point color.
            // $default: false
            point: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // $abbr: point
            pnt: {
                type:Boolean,
                default: false,
            },
            // $ver: v0.1.2
            // 하위 <em>ur-segment-button</em>의 모양새를 solid-button 스타일로 정의합니다.
            // #Define the appearance of the child <em>ur-segment-button</em> in the solid-button style.
            // $default: false
            solid: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // $abbr: solid
            sol: {
                type:Boolean,
                default: false,
            },
            // $ver: v0.1.2
            // 하위 <em>ur-segment-button</em>의 모양새를 border-button 스타일로 정의합니다.
            // #Define the appearance of the child <em>ur-segment-button</em> with the border-button style.
            // $default: false
            border: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // $abbr: border
            bor: {
                type:Boolean,
                default: false,
            },
            // $ver: v0.2.0
            // 하위 <em>ur-segment-button</em>의 크기를 결정합니다. 'small', 'medium', 'large' 두 가지 중 하나를 입력해야 합니다.
            // #The size You must enter one of three types: small, large or medium.
            size:  {type: String, default: undefined},
            // $ver: v0.1.2
            // 하위 <em>ur-segment-button</em>의 크기를 large으로 정의합니다.
            // #Define the size of the child <em>ur-segment-button</em> as large.
            // $default: false
            large: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // $abbr: large
            lg: {
                type:Boolean,
                default: false,
            },
            // $ver: v0.1.2
            // 하위 <em>ur-segment-button</em>의 크기를 medium으로 정의합니다.
            // #Define the size of the child <em>ur-segment-button</em> as medium.
            // $default: false
            medium: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // $abbr: medium
            md: {
                type:Boolean,
                default: false,
            },
            // $ver: v0.1.2
            // 하위 <em>ur-segment-button</em>의 크기를 small로 정의합니다.
            // #Define the size of the child <em>ur-segment-button</em> as small.
            // $default: false
            small: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // $abbr: small
            sm: {
                type:Boolean,
                default: false,
            },
            clearable: Boolean
            /* [FROM VALIDATOR] */
            // rules
            // disabled
            // lazy
            // noShake
            /********************/
        },
        data() {return {
            default : {
                size: 'medium',
                style: 'border',
                color: 'default'
            }
            /* [FROM VALIDATOR] */
            // hasError
            // errorMessage
            // showValid
            // shake
            /********************/
        }},
        computed: {
            $_style() {
                if(this.border || this.bor) {return 'border'}
                if(this.solid || this.sol) {return 'solid'}
                return this.default.style;
            },
            $_color() {
                if(this.color) {return this.color}
                if(this.primary || this.prim) {return 'primary'}
                if(this.point || this.pnt) {return 'point'}
                return this.default.color;
            },
            $_size() {
                if(this.size ==='medium'|| this.medium || this.md) {return 'medium'}
                if(this.size ==='large'|| this.large || this.lg) {return 'large'}
                if(this.size ==='small'|| this.small || this.sm) {return 'small'}
                if(this.urInput) {return this.urInput.size}
                return this.default.size;
            },
            wrapperClass() { return {
                'ur-validator--error': this.hasError === true,
                'ur-validator--valid': this.showValid && this.hasError === false,
                'ur-validator--shake': this.shake
            }},
            sharedData() {
                let rtn = {}, odf = Object.defineProperty;
                odf(rtn, "checked"     , {get:()=>this.checked});
                odf(rtn, "emit"        , {get:()=>this.emit});
                odf(rtn, "click"        , {get:()=>this.click});
                odf(rtn, 'disabled' , {get:()=>this.disabled});
                odf(rtn, 'hasError' , {get:()=>this.hasError});
                odf(rtn, 'style' , {get:()=>this.$_style});
                odf(rtn, 'color' , {get:()=>this.$_color});
                odf(rtn, 'clearable' , {get:()=>this.clearable});
                return rtn;
            },
            messageShow() {
                if(this.hasError === undefined) {
                    return this.guideMessage;
                }
                if(this.hasError === true) {
                    return this.errorMessage;
                }
                if(this.hasError === false) {
                    return this.successMessage || this.guideMessage;
                }
                return undefined;
            },
            /* [FROM VALIDATOR] */
            // isValidatable
            // el
            validateTarget() {return this.checked;}, // validation setting
            /********************/
        },
        watch: {
            validateTarget(val) {
                this.validateOnEvent(); // whenever checked value changes, execute validate() if lazy is false
            },
            successMessage: {
                immediate: true,
                handler(val) {
                    this.showValid = !!val;
                }
            }
        },
        provide() {
            let rtn = {urSegmentWrapper:{}};
            let odf = Object.defineProperty;
            rtn.urSegmentWrapper[this.group] = this.sharedData;
            let urInput = {};
            odf(urInput, 'size', {get: ()=>this.$_size});
            rtn['urInput'] = urInput;
            return rtn;
        },
        methods: {
            /* [FROM VALIDATOR] */
            // validate()        --+
            // isValid()         --+-- exposed methods for manual validate control
            // clearValidation() --+
            // validateOnEvent() -> should be set by each component which uses urValidatorMixin
            /********************/

            emit(val) {
                // $ver: v0.1.1
                // $arg: updated v-model value
                // v-model에 설정된값(checked)을 업데이트합니다.
                // # update v-model value(checked props).
                this.$emit('input', val);
            },
            click(e) {
                // $ver: v0.1.2
                // $arg: click event
                // click 시 이벤트를 호출합니다.
                // # Call event on click.
                this.$emit('click', e);
            }
        }
    }
</script>
